import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path d="M4.5 9.75a5.25 5.25 0 1110.501.001A5.25 5.25 0 014.5 9.75zm10.686 3.99A6.712 6.712 0 0016.5 9.75a6.75 6.75 0 10-6.75 6.75 6.712 6.712 0 003.99-1.314L19.555 21 21 19.555l-5.814-5.815z" fillRule="evenodd" /></svg>);